export enum FeatureToggle {
  OFF = 'off',
  ON = 'on',
  LOADING = 'loading',
  CONTROL = 'control',
}
